// B1-INT - Ünite 1: Temel Mülakat Soruları
// B1 seviyesinde basit İngilizce ile gerçekçi mülakat senaryoları

export const B1INT_UNIT_1 = {
  'B1INT-U1-L1': {
    id: 'B1INT-U1-L1',
    title: 'Tell me about yourself',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Önemli?',
          content: 'Bu soru neredeyse HER mülakatın ilk sorusudur. İlk izlenim çok önemli!\n\n• Kendinizi tanıtma şansı\n• 1-2 dakika içinde özet\n• Profesyonel, kişisel değil\n• İşle alakalı bilgiler'
        },
        {
          type: 'framework',
          title: '📋 Basit Yapı: Geçmiş → Şimdi → Gelecek',
          content: '**1. GEÇMIŞ (Past):** Eğitim ve deneyim\n"I studied... I worked..."\n\n**2. ŞİMDİ (Present):** Şu an ne yapıyorsun\n"Currently, I work... I am..."\n\n**3. GELECEK (Future):** Neden bu iş\n"I want to... That\'s why I\'m here..."'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: İyi Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'So, tell me about yourself.',
              translation: 'Peki, bana kendinizden bahsedin.'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Of course! My name is Elif, and I\'m from Istanbul.',
              translation: 'Tabii! Adım Elif ve İstanbul\'luyum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I studied Tourism at university. After that, I worked in a hotel for two years. I was a receptionist.',
              translation: 'Üniversitede Turizm okudum. Sonra iki yıl bir otelde çalıştım. Resepsiyonisttim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I really enjoyed helping guests and making them happy. Now, I want to do the same thing in the sky!',
              translation: 'Misafirlere yardım etmeyi ve onları mutlu etmeyi çok sevdim. Şimdi aynı şeyi gökyüzünde yapmak istiyorum!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'That\'s why I\'m applying for cabin crew. I love meeting people from different countries.',
              translation: 'Bu yüzden kabin memurluğuna başvuruyorum. Farklı ülkelerden insanlarla tanışmayı seviyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi Bir Cevap?',
          content: '✅ Kısa ve net cümleler\n✅ Geçmiş → Şimdi → Gelecek yapısı\n✅ İşle alakalı deneyim (otel)\n✅ Neden bu iş istediğini söyledi\n✅ Pozitif ve enerjik'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Tell me about yourself.',
              translation: 'Bana kendinizden bahsedin.'
            },
            {
              speaker: 'Kötü Cevap 1',
              text: 'Well, I was born in 1998. I have two sisters. I like watching TV and sleeping. My favorite color is blue.',
              translation: '1998\'de doğdum. İki kız kardeşim var. TV izlemeyi ve uyumayı severim. En sevdiğim renk mavi.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevabın Sorunları',
          content: '❌ Kişisel bilgiler (doğum tarihi, kardeşler)\n❌ İşle alakasız hobiler\n❌ Profesyonel değil\n❌ Neden bu işi istediğini söylemedi'
        },
        {
          type: 'tip',
          content: '💡 KURAL: Sadece iş ile alakalı şeyler söyle. Ailen, hobin, sevdiğin renk = HAYIR!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Tell me about yourself" sorusunda ne söylemelisin?',
          options: [
            'Ailem, hobilerim, doğum tarihim',
            'Eğitim, iş deneyimi, neden bu iş',
            'Maaş beklentim',
            'Sadece ismim'
          ],
          correctIndex: 1,
          explanation: 'Profesyonel bilgiler: eğitim, deneyim ve neden bu işi istediğin.'
        },
        {
          type: 'multipleChoice',
          question: 'Hangi cümle B1 seviyesinde doğru?',
          options: [
            'I studied Tourism at university.',
            'I have been studying Tourism.',
            'I was used to study Tourism.',
            'I did studied Tourism.'
          ],
          correctIndex: 0,
          explanation: 'Simple Past: "I studied" - geçmişte tamamlanmış eylem.'
        }
      ]
    }
  },

  'B1INT-U1-L2': {
    id: 'B1INT-U1-L2',
    title: 'Why do you want to be a cabin crew?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Mülakatçı motivasyonunuzu anlamak istiyor:\n\n• Gerçekten istiyor musun?\n• Sadece seyahat için mi?\n• İşin zorluklarını biliyor musun?\n• Uzun süre kalacak mısın?'
        },
        {
          type: 'info',
          title: '✅ İyi Sebepler (Good Reasons)',
          content: '• I love helping people\n• I enjoy working in a team\n• I like meeting new people\n• I want to use my language skills\n• I am passionate about service'
        },
        {
          type: 'warning',
          title: '❌ Kötü Sebepler (Bad Reasons)',
          content: '• I want to travel for free ❌\n• I want to see the world ❌\n• The uniform is nice ❌\n• I heard the salary is good ❌\n• I don\'t know what else to do ❌'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: İyi Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to become a cabin crew member?',
              translation: 'Neden kabin memuru olmak istiyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I want to be cabin crew because I love helping people. When I worked at the hotel, the best part was making guests happy.',
              translation: 'Kabin memuru olmak istiyorum çünkü insanlara yardım etmeyi seviyorum. Otelde çalışırken en güzel kısım misafirleri mutlu etmekti.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also enjoy working with different people. Every day at an airport is different - new passengers, new stories.',
              translation: 'Ayrıca farklı insanlarla çalışmaktan keyif alıyorum. Havalimanında her gün farklı - yeni yolcular, yeni hikayeler.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'And I speak three languages - Turkish, English, and German. I want to use these skills to help international passengers.',
              translation: 'Ve üç dil biliyorum - Türkçe, İngilizce ve Almanca. Bu becerileri uluslararası yolculara yardım etmek için kullanmak istiyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ "I love helping people" - hizmet odaklı\n✅ Otel deneyiminden örnek verdi\n✅ Dil becerisini vurguladı\n✅ "Travel" veya "free" kelimelerini kullanmadı'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to become a cabin crew member?',
              translation: 'Neden kabin memuru olmak istiyorsunuz?'
            },
            {
              speaker: 'Kötü Cevap',
              text: 'I want to travel the world for free! I love seeing new places. And the uniform looks really nice!',
              translation: 'Dünyayı bedava gezmek istiyorum! Yeni yerler görmeyi seviyorum. Ve üniforma çok güzel görünüyor!'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevabın Sorunları',
          content: '❌ "Travel for free" = İş değil, tatil istiyorsun\n❌ "Uniform looks nice" = Yüzeysel\n❌ Hizmet veya yolculardan bahsetmedi'
        },
        {
          type: 'tip',
          content: '💡 KURAL: ASLA "free travel" veya "see the world" deme. Bunun yerine "helping passengers" ve "service" kullan.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Hangisi İYİ bir sebep?',
          options: [
            'I want to travel for free.',
            'I love helping people and working in a team.',
            'The uniform is beautiful.',
            'I heard the salary is high.'
          ],
          correctIndex: 1,
          explanation: 'Hizmet ve takım çalışması = iyi motivasyon. Seyahat ve maaş = kötü motivasyon.'
        }
      ]
    }
  },

  'B1INT-U1-L3': {
    id: 'B1INT-U1-L3',
    title: 'Why our airline?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Şirketi araştırdın mı?\n\n• Gerçekten bu şirketi mi istiyorsun?\n• Yoksa herhangi bir havayolu mu?\n• Şirket hakkında ne biliyorsun?'
        },
        {
          type: 'info',
          title: '📚 Mülakat Öncesi Araştır!',
          content: '**Öğrenmen Gerekenler:**\n• Şirketin merkezi neresi?\n• Kaç ülkeye uçuyor?\n• Ne zaman kuruldu?\n• Sloganı ne?\n• Son haberler neler?'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Turkish Airlines',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to work for Turkish Airlines specifically?',
              translation: 'Özellikle neden Türk Hava Yolları\'nda çalışmak istiyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I want to work for Turkish Airlines because it\'s one of the best airlines in the world. You fly to more than 120 countries!',
              translation: 'Türk Hava Yolları\'nda çalışmak istiyorum çünkü dünyanın en iyi havayollarından biri. 120\'den fazla ülkeye uçuyorsunuz!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also love the idea of "Turkish hospitality." I read that THY treats passengers like family. That\'s exactly how I like to work.',
              translation: 'Ayrıca "Türk misafirperverliği" fikrini seviyorum. THY\'nin yolculara aile gibi davrandığını okudum. Ben de tam böyle çalışmayı seviyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'And Istanbul Airport is amazing - it\'s a big hub connecting East and West. I\'d be proud to work there.',
              translation: 'Ve İstanbul Havalimanı harika - Doğu ve Batı\'yı birleştiren büyük bir merkez. Orada çalışmaktan gurur duyardım.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ Somut bilgi (120+ ülke)\n✅ Şirket değeri (Turkish hospitality)\n✅ Hub bilgisi (İstanbul)\n✅ Araştırma yaptığı belli'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to work for Turkish Airlines?',
              translation: 'Neden Türk Hava Yolları\'nda çalışmak istiyorsunuz?'
            },
            {
              speaker: 'Kötü Cevap',
              text: 'Because it\'s a good company. And I\'m Turkish, so Turkish Airlines is good for me.',
              translation: 'Çünkü iyi bir şirket. Ve ben Türk\'üm, bu yüzden Türk Hava Yolları bana uygun.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevabın Sorunları',
          content: '❌ "Good company" = Herkes bunu söyler, spesifik değil\n❌ "I\'m Turkish" = Bu bir neden değil\n❌ Araştırma yok'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Why our airline?" sorusu için ne hazırlamalısın?',
          options: [
            'Sadece şirketin adını bilmek yeterli',
            'Şirketin kaç ülkeye uçtuğu, değerleri, son haberleri',
            'Maaş bilgileri',
            'Rakip şirketlerin isimleri'
          ],
          correctIndex: 1,
          explanation: 'Şirket araştırması: uçulan ülkeler, değerler, haberler. Bu, gerçekten istediğini gösterir.'
        }
      ]
    }
  },

  'B1INT-U1-L4': {
    id: 'B1INT-U1-L4',
    title: 'What are your strengths and weaknesses?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Mülakatçı öğrenmek istiyor:\n\n• Kendini tanıyor musun?\n• Dürüst müsün?\n• Zayıf yönlerinin farkında mısın?\n• Geliştirmek için ne yapıyorsun?'
        },
        {
          type: 'info',
          title: '💪 Güçlü Yönler (Strengths) - Örnekler',
          content: '• I am a good team player\n• I stay calm under pressure\n• I am patient with people\n• I learn new things quickly\n• I am good at communication\n• I speak multiple languages'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Güçlü Yön',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you say is your biggest strength?',
              translation: 'En büyük güçlü yönünüz nedir dersiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'My biggest strength is staying calm under pressure. In my hotel job, we sometimes had very busy nights with many guests arriving at once.',
              translation: 'En büyük güçlü yönüm baskı altında sakin kalmak. Otel işimde bazen aynı anda birçok misafirin geldiği çok yoğun geceler olurdu.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I learned to prioritize - help the most urgent cases first, and always keep smiling. My manager said I was "the calm one" in the team.',
              translation: 'Önceliklendirmeyi öğrendim - önce en acil durumlarla ilgilen ve her zaman gülümsemeye devam et. Müdürüm takımda "sakin olan" olduğumu söylerdi.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ Somut güçlü yön (staying calm)\n✅ Örnek verdi (busy hotel nights)\n✅ Kanıt gösterdi (manager\'s words)'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Zayıf Yön',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'And what about your weakness? What would you like to improve?',
              translation: 'Peki zayıf yönünüz? Neyi geliştirmek istersiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I sometimes worry too much about small details. In the past, I would spend extra time making everything perfect.',
              translation: 'Bazen küçük detaylar hakkında çok fazla endişelenirim. Geçmişte her şeyi mükemmel yapmak için ekstra zaman harcardım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'But I\'m working on this. Now I ask myself: "Is this important for the guest?" If yes, I spend time. If not, I move on.',
              translation: 'Ama bunun üzerinde çalışıyorum. Şimdi kendime soruyorum: "Bu misafir için önemli mi?" Evet ise zaman harcıyorum. Değilse devam ediyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi Bir Zayıflık Cevabı?',
          content: '✅ Gerçek bir zayıflık (detaylara takılma)\n✅ Ama aslında pozitif (perfectionist)\n✅ Nasıl geliştirdiğini anlattı\n✅ "Zayıflığım yok" demedi'
        },
        {
          type: 'scenario',
          title: '❌ Kötü Zayıflık Cevapları',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'I don\'t have any weaknesses. I\'m perfect at everything.',
              translation: 'Hiç zayıf yönüm yok. Her şeyde mükemmelim.'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'I\'m often late to work.',
              translation: 'İşe sık sık geç kalırım.'
            },
            {
              speaker: 'Kötü Cevap 3',
              text: 'I get angry easily when people are rude.',
              translation: 'İnsanlar kaba olduğunda kolayca sinirleniyorum.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Neden Kötü?',
          content: '**Cevap 1:** Kimse mükemmel değil, samimiyetsiz\n**Cevap 2:** Dakiklik = işte kritik\n**Cevap 3:** Öfke = müşteri hizmetinde kabul edilemez'
        },
        {
          type: 'tip',
          content: '💡 İyi zayıflık seçimi: Gerçek olsun + Çok ciddi olmasın + Üzerinde çalışıyor ol'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Hangisi mülakata uygun bir zayıflık?',
          options: [
            'I get angry with rude customers.',
            'I am often late to work.',
            'I sometimes focus too much on details, but I\'m working on it.',
            'I don\'t have any weaknesses.'
          ],
          correctIndex: 2,
          explanation: 'Detaylara takılmak aslında pozitif görülebilir ve "working on it" büyüme gösterir.'
        }
      ]
    }
  },

  'B1INT-U1-L5': {
    id: 'B1INT-U1-L5',
    title: 'Pratik: Kendini Tanıtma',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Ünite 1 Pratiği',
          content: 'Şimdi öğrendiklerini birleştiriyoruz! Tam bir tanışma mülakatı göreceksin.'
        },
        {
          type: 'scenario',
          title: '✈️ TAM MÜLAKAT: İlk 5 Dakika',
          dialogues: [
            {
              speaker: 'Ortam',
              text: 'Interview room. You enter and see a friendly HR person smiling.',
              translation: 'Mülakat odası. Giriyorsun ve gülümseyen bir İK temsilcisi görüyorsun.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Good morning! Please have a seat. How are you today?',
              translation: 'Günaydın! Lütfen oturun. Bugün nasılsınız?'
            },
            {
              speaker: 'Aday',
              text: 'Good morning! I\'m very well, thank you. A little nervous but excited to be here!',
              translation: 'Günaydın! Çok iyiyim, teşekkür ederim. Biraz heyecanlıyım ama burada olmaktan mutluyum!'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Dürüst ol - "a little nervous" demek samimi. Ama "excited" ile dengele.',
              translation: ''
            },
            {
              speaker: 'Mülakatçı',
              text: 'Great! Let\'s start. Tell me about yourself.',
              translation: 'Harika! Başlayalım. Bana kendinizden bahsedin.'
            },
            {
              speaker: 'Aday',
              text: 'Sure! My name is Ayşe, and I\'m 24 years old. I\'m from Ankara.',
              translation: 'Tabii! Adım Ayşe, 24 yaşındayım. Ankara\'lıyım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I studied English Language at university. Then I worked as a customer service agent at a call center for 1 year.',
              translation: 'Üniversitede İngiliz Dili okudum. Sonra bir çağrı merkezinde 1 yıl müşteri hizmetleri temsilcisi olarak çalıştım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I learned how to help customers, solve problems, and stay calm on the phone. Now I want to use these skills as cabin crew.',
              translation: 'Müşterilere yardım etmeyi, sorunları çözmeyi ve telefonda sakin kalmayı öğrendim. Şimdi bu becerileri kabin memuru olarak kullanmak istiyorum.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Nice! Why do you want to be cabin crew?',
              translation: 'Güzel! Neden kabin memuru olmak istiyorsunuz?'
            },
            {
              speaker: 'Aday',
              text: 'I want to be cabin crew because I love working with people. At the call center, I helped hundreds of customers every week, and I really enjoyed making them happy.',
              translation: 'Kabin memuru olmak istiyorum çünkü insanlarla çalışmayı seviyorum. Çağrı merkezinde her hafta yüzlerce müşteriye yardım ettim ve onları mutlu etmekten gerçekten keyif aldım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Also, I speak Turkish, English, and a little Spanish. I want to meet people from different countries and help them have a good flight.',
              translation: 'Ayrıca Türkçe, İngilizce ve biraz İspanyolca biliyorum. Farklı ülkelerden insanlarla tanışmak ve iyi bir uçuş geçirmelerine yardım etmek istiyorum.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Why Turkish Airlines?',
              translation: 'Neden Türk Hava Yolları?'
            },
            {
              speaker: 'Aday',
              text: 'Turkish Airlines is my dream company! You fly to over 120 countries - that\'s more than any other airline.',
              translation: 'Türk Hava Yolları hayalimdeki şirket! 120\'den fazla ülkeye uçuyorsunuz - diğer tüm havayollarından fazla.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also love the "Turkish hospitality" concept. THY is known for treating passengers like guests at home. That\'s exactly the kind of service I believe in.',
              translation: '"Türk misafirperverliği" kavramını da seviyorum. THY, yolculara evdeki misafirler gibi davranmasıyla tanınıyor. İnandığım hizmet tam olarak bu.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Good. What are your strengths?',
              translation: 'İyi. Güçlü yönleriniz neler?'
            },
            {
              speaker: 'Aday',
              text: 'My biggest strength is patience. At the call center, some customers were angry or confused. I always listened carefully and stayed calm until they felt better.',
              translation: 'En büyük güçlü yönüm sabır. Çağrı merkezinde bazı müşteriler öfkeli veya kafası karışmıştı. Kendilerini daha iyi hissedene kadar her zaman dikkatle dinledim ve sakin kaldım.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'And your weakness?',
              translation: 'Peki zayıf yönünüz?'
            },
            {
              speaker: 'Aday',
              text: 'I used to be shy about speaking in front of groups. But I worked on it - I took a public speaking course, and now I feel much more confident.',
              translation: 'Eskiden grupların önünde konuşma konusunda utangaçtım. Ama üzerinde çalıştım - bir topluluk önünde konuşma kursu aldım ve şimdi kendimi çok daha güvenli hissediyorum.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Thank you! That was a great introduction.',
              translation: 'Teşekkürler! Bu harika bir tanışmaydı.'
            }
          ]
        },
        {
          type: 'summary',
          title: '📊 Mülakat Analizi',
          content: '**✅ Aday şunları iyi yaptı:**\n• Basit, net İngilizce kullandı\n• Her soruya örnek verdi\n• Şirket araştırması yaptığı belli\n• Zayıflığı pozitife çevirdi\n• Gülümsedi ve pozitif kaldı'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Bu mülakatta adayın kullandığı İngilizce seviyesi:',
          options: [
            'Çok karmaşık, anlaşılması zor',
            'B1 seviyesi - basit, net, anlaşılır',
            'Çok basit, yetersiz',
            'Native seviyesi'
          ],
          correctIndex: 1,
          explanation: 'B1 seviyesinde kısa, net cümleler kullanmak mükemmel. Karmaşık gramer gerekli değil!'
        }
      ]
    }
  },

  'B1INT-U1-EXAM': {
    id: 'B1INT-U1-EXAM',
    title: 'Unit 1 Exam: Basic Interview Questions',
    type: 'exam',
    content: {
      timeLimit: 20,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'When answering "Tell me about yourself", what should you focus on?',
          options: [
            'Your family, hobbies, and birth date',
            'Your education, work experience, and why you want this job',
            'Your salary expectations',
            'Your favorite color and foods'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is the WORST answer to "Why do you want to be cabin crew?"',
          options: [
            'I love helping people and providing excellent service',
            'I want to travel for free and see the world',
            'I enjoy working in a diverse team environment',
            'I want to use my language skills professionally'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you prepare before answering "Why our airline?"',
          options: [
            'Only the company name',
            'Company values, destinations, recent news, and achievements',
            'Information about competitor airlines',
            'Salary and benefits information'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is a GOOD answer to "What is your weakness?"',
          options: [
            'I don\'t have any weaknesses',
            'I am often late to work',
            'I focus too much on details, but I\'m working on managing my time better',
            'I get angry easily with rude people'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Which sentence is grammatically correct for describing past experience?',
          options: [
            'I have been working in hotel.',
            'I worked in a hotel for 2 years.',
            'I was used to work in hotel.',
            'I did worked in a hotel.'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What structure should you use for "Tell me about yourself"?',
          options: [
            'Future → Present → Past',
            'Past → Present → Future',
            'Only talk about your childhood',
            'Only talk about your future plans'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which phrase best introduces yourself in an interview?',
          options: [
            'I was born in 1998 and I like sleeping.',
            'My name is Sarah and I have 3 years of customer service experience.',
            'I don\'t know what to say.',
            'My favorite hobby is watching TV.'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B1INT_UNIT_1;
